import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import mosadsAPI from '../../utils/api/mosads';

export const fetchMosadEmployees = createAsyncThunk(
  'employees/fetchMosadEmployees',
  async (_, { rejectWithValue }) => {
    try {
      const response = await mosadsAPI.getEmployees();
      return response?.data ?? [];
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const inviteEmployees = createAsyncThunk(
  'employees/inviteEmployees',
  async (mails, { rejectWithValue }) => {
    try {
      const response = await mosadsAPI.addEmployees(mails);
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const updateEmployee = createAsyncThunk(
  'employees/updateEmployee',
  async ({ usr_id, firstName, lastName, role, status }, { rejectWithValue }) => {
    try {
      const response = await mosadsAPI.updateEmployee(usr_id, {
        firstName,
        lastName,
        role,
        status,
      });
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const initialState = {
  employeesList: [],
  loading: false,
  error: null,
};

const employeesSlice = createSlice({
  name: 'employees',
  initialState,
  reducers: {
    clearEmployeesState: (state) => {
      state.employeesList = [];
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchMosadEmployees.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchMosadEmployees.fulfilled, (state, action) => {
        state.loading = false;
        state.employeesList = Array.isArray(action.payload) ? action.payload : [];
      })
      .addCase(fetchMosadEmployees.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(inviteEmployees.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(inviteEmployees.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(inviteEmployees.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(updateEmployee.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateEmployee.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(updateEmployee.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearEmployeesState } = employeesSlice.actions;
export default employeesSlice.reducer;
